export default "__VITE_ASSET__kOrqY2NG__"